class VerificationTripModel {
  readonly createdOn: string;
  readonly id:number;
  readonly clientId:string;
  readonly tripId:number;
  readonly verificationStatus:string;
  readonly isReviewed:boolean;
  readonly fio:string;
  constructor({
    createdOn,
    id,
    clientId,
    tripId,
    verificationStatus,
    isReviewed,
    fio,
  }) {
    this.createdOn = createdOn;
    this.id=id;
    this.clientId=clientId;
    this.verificationStatus=verificationStatus;
    this.tripId=tripId;
    this.isReviewed=isReviewed;
    this.fio=fio;
  }
}

export default VerificationTripModel;
